import { render } from "./pageNotFoundComponent.vue?vue&type=template&id=52e4ba56"
import script from "./pageNotFoundComponent.vue?vue&type=script&lang=js"
export * from "./pageNotFoundComponent.vue?vue&type=script&lang=js"

import "./pageNotFoundComponent.vue?vue&type=style&index=0&id=52e4ba56&lang=css"

import exportComponent from "/home/runner/work/Agile-bot-web-dashboard/Agile-bot-web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__